import { jsx as _jsx } from "react/jsx-runtime";
import { Box, freddyTheme, Link, Typography } from '@coolblue-development/freddy';
import { ArrowLeft } from '@coolblue-development/icons';
export default function HamburgerMenuParent({ item, onNavigateToParent, }) {
    return (_jsx(Box, { alignSelf: "flex-start", children: _jsx(Link, { rel: item.noFollow ? 'nofollow' : 'follow', href: item.url, variant: "subtle", startIcon: _jsx(ArrowLeft, { fill: freddyTheme.color.icon.subtle }), onClick: event => {
                event.preventDefault();
                onNavigateToParent();
            }, children: _jsx(Typography, { component: "span", children: item.title }) }) }));
}
//# sourceMappingURL=HamburgerMenuParent.js.map